module.exports = __webpack_public_path__ + "static/media/15.1eb55c42.png";